/**
 * PERSONA 5 ROYAL CURSOR PARALLAX ENGINE (AAA 3D SPATIAL DEPTH)
 * Multi-layer dampening lerp physics engine for mouse interaction
 */

class Persona5CursorPhysics {
  constructor(overlay) {
    this.overlay = overlay;
    if (!this.overlay) return;

    this.cardStack = this.overlay.querySelector('.p5r-card-stack');
    this.bgPolygon = this.overlay.querySelector('.p5r-layer-4-red-poly');
    this.topSlash = this.overlay.querySelector('.p5r-layer-5-slash');
    this.descPanel = this.overlay.querySelector('.p5r-description-panel');
    this.hudStamp = this.overlay.querySelector('.p5r-hud-stamp');
    this.titleHeader = this.overlay.querySelector('.p5r-menu-title-header');
    this.bgShadow = this.overlay.querySelector('.p5r-bg-shadow-drift');
    this.stamp1 = this.overlay.querySelector('.p5r-stamp-1');
    this.stamp2 = this.overlay.querySelector('.p5r-stamp-2');

    this.mouseX = 0;
    this.mouseY = 0;
    this.targetX = 0;
    this.targetY = 0;
    
    this.isTracking = false;
    this.rafId = null;

    this.init();
  }

  init() {
    this.mouseMoveHandler = (e) => this.onMouseMove(e);
  }

  start() {
    this.isTracking = true;
    window.addEventListener('mousemove', this.mouseMoveHandler);
    this.loop();
  }

  stop() {
    this.isTracking = false;
    window.removeEventListener('mousemove', this.mouseMoveHandler);
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
    }
  }

  onMouseMove(e) {
    // Normalize coordinates (-1 to +1)
    this.targetX = (e.clientX / window.innerWidth - 0.5) * 2;
    this.targetY = (e.clientY / window.innerHeight - 0.5) * 2;
  }

  loop() {
    if (!this.isTracking) return;

    // Dampened Lerp Physics (0.075 interpolation factor for ultra smooth feel)
    this.mouseX += (this.targetX - this.mouseX) * 0.075;
    this.mouseY += (this.targetY - this.mouseY) * 0.075;

    this.applyParallax();

    this.rafId = requestAnimationFrame(() => this.loop());
  }

  applyParallax() {
    if (typeof gsap === 'undefined') return;
    if (this.overlay.dataset.parallaxEnabled === 'false') return;

    const intensity = (parseFloat(this.overlay.dataset.parallaxIntensity) || 100) / 100;

    // Multi-Layer Parallax Spatial Offsets:
    // 1. Menu Stack (Foreground Primary): 4.5px offset
    if (this.cardStack) {
      gsap.set(this.cardStack, {
        x: this.mouseX * 4.5 * intensity,
        y: this.mouseY * 4.5 * intensity,
        overwrite: 'auto'
      });
    }

    // 2. Editorial Magazine Dossier Panel (Opposing Depth): -6px offset
    if (this.descPanel) {
      gsap.set(this.descPanel, {
        x: this.mouseX * -6 * intensity,
        y: this.mouseY * -6 * intensity,
        overwrite: 'auto'
      });
    }

    // 3. Background Red Polygon (Deep Layer): 9px offset
    if (this.bgPolygon) {
      gsap.set(this.bgPolygon, {
        x: this.mouseX * 9 * intensity,
        y: this.mouseY * 9 * intensity,
        overwrite: 'auto'
      });
    }

    // 4. Top Slash: 2px offset
    if (this.topSlash) {
      gsap.set(this.topSlash, {
        x: this.mouseX * 2 * intensity,
        y: this.mouseY * 2 * intensity,
        overwrite: 'auto'
      });
    }

    // 5. HUD System Stamp & Title Header: 3.5px offset
    if (this.hudStamp) {
      gsap.set(this.hudStamp, {
        x: this.mouseX * 3 * intensity,
        y: this.mouseY * 3 * intensity,
        overwrite: 'auto'
      });
    }

    if (this.titleHeader) {
      gsap.set(this.titleHeader, {
        x: this.mouseX * 3.5 * intensity,
        y: this.mouseY * 3.5 * intensity,
        overwrite: 'auto'
      });
    }

    // 6. Background Graphic Watermark Stamps (Deep Atmospheric Layer): -14px and 16px offset
    if (this.stamp1) {
      gsap.set(this.stamp1, {
        x: this.mouseX * -14 * intensity,
        y: this.mouseY * -14 * intensity,
        overwrite: 'auto'
      });
    }

    if (this.stamp2) {
      gsap.set(this.stamp2, {
        x: this.mouseX * 16 * intensity,
        y: this.mouseY * 16 * intensity,
        overwrite: 'auto'
      });
    }

    // 7. Background Ambient Radial Shadow Drift: -12px offset
    if (this.bgShadow) {
      gsap.set(this.bgShadow, {
        x: this.mouseX * -12 * intensity,
        y: this.mouseY * -12 * intensity,
        overwrite: 'auto'
      });
    }
  }

}

window.Persona5CursorPhysics = Persona5CursorPhysics;


